module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-betland-up@1x.png?0.0.53";